module.exports = __webpack_public_path__ + "img/icon_error.e0f6e1e1.png";